/* Store-specific wishlist customisations.
   1. Heart button on grid items removes the item directly (no options popup).
   2. Add to cart on a multi-size product opens a size selector panel first.
   3. Add to cart stays clickable when the wishlisted size is sold out but
      other sizes are not, and any size in the cart counts as added to cart. */
(function () {
  var SIZE_OPTION_NAMES = ['size'];
  var SELECT_SIZE_LABEL = 'Select a size';
  var PANEL_CLASS = 'swymcs-size-panel';
  var EMPTY_WISHLIST_TITLE = 'You don’t have any products in your wishlist';
  var GUEST_EMPTY_LOGIN_CTA = 'Log in to view your wishlist';

  /* --------------------------------------------------------------------
     1. Direct remove from the heart button
     Uses SwymStorefrontLayoutWishlistItem.handleDirectRemove(), which already
     exists in storefront-layout-components.js but isn't wired to a click there.
     -------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.swym-storefront-layout-grid-item-option-button:not(.swym-storefront-layout-delete-btn)');
    if (!btn) return;

    var itemEl = btn.closest('swym-storefront-layout-item');
    if (!itemEl || typeof itemEl.handleDirectRemove !== 'function') return;

    event.stopPropagation();
    event.preventDefault();
    itemEl.handleDirectRemove();
  }, true);

  /* --------------------------------------------------------------------
     Shared helpers
     -------------------------------------------------------------------- */
  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function getStrings() {
    return (window.SwymStorefrontLayoutContext && window.SwymStorefrontLayoutContext.Strings) || {};
  }

  function isSaveForLaterItem(itemEl) {
    var listItemType = window.SwymStorefrontLayoutContext &&
      window.SwymStorefrontLayoutContext.ListItemType;
    return !!(listItemType && itemEl.listItemType === listItemType.SaveForLaterItem);
  }

  function getSizeOptionIndex(options) {
    for (var i = 0; i < options.length; i++) {
      var name = options[i] && options[i].name;
      if (typeof name === 'string' && SIZE_OPTION_NAMES.indexOf(name.trim().toLowerCase()) !== -1) {
        return i;
      }
    }
    return -1;
  }

  /* Returns { optionName, sizes: [{size, variantId, available}] } for the size
     option, holding every other option at the item's current variant. */
  function getSizeVariants(itemEl) {
    var productData = itemEl.item && itemEl.item.productData;
    var variants = productData && productData.variants;
    var options = productData && productData.options;
    if (!variants || !variants.length || !options || !options.length) return null;

    var sizeIndex = getSizeOptionIndex(options);
    if (sizeIndex === -1) return null;

    var reference = itemEl.selectedVariant || variants.filter(function (variant) {
      return String(variant.id) === String(itemEl.item.epi);
    })[0] || variants[0];

    var sizeKey = 'option' + (sizeIndex + 1);

    var sizes = variants.filter(function (variant) {
      return options.every(function (option, index) {
        if (index === sizeIndex) return true;
        var key = 'option' + (index + 1);
        return variant[key] === reference[key];
      });
    }).map(function (variant) {
      return { size: variant[sizeKey], variantId: variant.id, available: !!variant.available };
    });

    return { optionName: options[sizeIndex].name, sizes: sizes };
  }

  /* The other sizes of this product, only when there is more than one. */
  function getSizeSiblings(itemEl) {
    var sizeData = getSizeVariants(itemEl);
    if (!sizeData || sizeData.sizes.length < 2) return null;
    return sizeData.sizes;
  }

  function isVariantInCart(variantId) {
    try {
      return !!(window._swat && window._swat.platform &&
        window._swat.platform.isInDeviceCart(variantId));
    } catch (error) {
      return false;
    }
  }

  function anySizeSiblingInCart(itemEl) {
    var sizes = getSizeSiblings(itemEl);
    if (!sizes) return false;
    return sizes.some(function (entry) { return isVariantInCart(entry.variantId); });
  }

  function hasAvailableSizeSibling(itemEl) {
    var sizes = getSizeSiblings(itemEl);
    if (!sizes) return false;
    return sizes.some(function (entry) { return entry.available; });
  }

  /* --------------------------------------------------------------------
     2. Size selector panel
     -------------------------------------------------------------------- */
  function closeAllPanels() {
    document.querySelectorAll('.' + PANEL_CLASS).forEach(function (panel) {
      panel.remove();
    });
  }

  function buildPanel(sizeData, addToCartLabel) {
    var panel = document.createElement('div');
    panel.className = PANEL_CLASS;
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', sizeData.optionName);

    var chips = sizeData.sizes.map(function (entry) {
      return '<button type="button" class="swymcs-size-chip' +
        (entry.available ? '' : ' swymcs-size-chip-unavailable') +
        '" data-variant-id="' + escapeHtml(entry.variantId) + '"' +
        (entry.available ? '' : ' disabled aria-disabled="true"') +
        '>' + escapeHtml(entry.size) + '</button>';
    }).join('');

    panel.innerHTML =
      '<div class="swymcs-size-panel-title">' + escapeHtml(sizeData.optionName) + '</div>' +
      '<div class="swymcs-size-chips">' + chips + '</div>' +
      '<button type="button" class="swymcs-size-panel-cta" disabled>' + escapeHtml(SELECT_SIZE_LABEL) + '</button>';

    panel.dataset.addToCartLabel = addToCartLabel;
    return panel;
  }

  function openPanel(itemEl, addToCartButton, sizeData) {
    closeAllPanels();

    var card = itemEl.querySelector('.swym-storefront-layout-grid-item');
    if (!card) return;

    var panel = buildPanel(sizeData, getStrings().addToCart || 'Add To Cart');
    var cta = panel.querySelector('.swymcs-size-panel-cta');
    var selectedVariantId = null;

    panel.addEventListener('click', function (event) {
      var chip = event.target.closest('.swymcs-size-chip');
      if (chip && !chip.disabled) {
        panel.querySelectorAll('.swymcs-size-chip').forEach(function (other) {
          other.classList.toggle('swymcs-size-chip-selected', other === chip);
        });
        selectedVariantId = chip.dataset.variantId;
        cta.disabled = false;
        cta.textContent = panel.dataset.addToCartLabel;
        return;
      }

      if (event.target.closest('.swymcs-size-panel-cta') && selectedVariantId) {
        addSelectedSizeToCart(itemEl, cta, selectedVariantId);
      }
    });

    card.appendChild(panel);
  }

  /* handleAddToCart() reads the variant from the item's data-epi attribute, so
     point that at the chosen size for the duration of the (synchronous) call
     and restore it afterwards - the wishlisted variant itself is unchanged. */
  function addSelectedSizeToCart(itemEl, cta, variantId) {
    var originalEpi = itemEl.dataset.epi;

    var cachedVariants = (itemEl.item && itemEl.item.productData && itemEl.item.productData.variants) || [];
    var cachedVariant = cachedVariants.filter(function (v) { return String(v.id) === String(variantId); })[0];
    console.log('[swym-debug] addSelectedSizeToCart', {
      variantId: variantId,
      wishlistedEpi: originalEpi,
      cachedVariantPrice: cachedVariant && cachedVariant.price,
      itemTopLevelPr: itemEl.item && itemEl.item.pr,
      itemTopLevelOp: itemEl.item && itemEl.item.op
    });

    itemEl.dataset.epi = variantId;
    try {
      itemEl.handleAddToCart({ preventDefault: function () {}, target: cta });
    } finally {
      itemEl.dataset.epi = originalEpi;
    }
  }

  document.addEventListener('click', function (event) {
    var addToCartButton = event.target.closest('.swym-storefront-layout-grid-item-add-to-cart-button[data-action="add-to-cart"]');

    if (!addToCartButton) {
      if (!event.target.closest('.' + PANEL_CLASS)) closeAllPanels();
      return;
    }

    var itemEl = addToCartButton.closest('swym-storefront-layout-item');
    if (!itemEl || typeof itemEl.handleAddToCart !== 'function') return;

    // Save for Later cards use move-to-cart, not add-to-cart - leave them alone.
    if (isSaveForLaterItem(itemEl)) return;

    var sizeData = getSizeVariants(itemEl);
    if (!sizeData || sizeData.sizes.length < 2) return; // single size or no size option

    event.preventDefault();
    event.stopPropagation();
    openPanel(itemEl, addToCartButton, sizeData);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllPanels();
  });

  /* --------------------------------------------------------------------
     3. Button label and enabled state across sizes
     -------------------------------------------------------------------- */
  function isAddToCartDisabledByTag(itemEl) {
    var settings = window._swat && window._swat.retailerSettings;
    if (!settings || !settings.Wishlist || !settings.Wishlist.TagBasedActionEnabled) return false;
    if (typeof itemEl.isTagAvailable !== 'function') return false;
    var tag = (settings.UI && settings.UI.DisabledAddtoCartTag) || 'swym-disabled-addtocart-with-text';
    return !!itemEl.isTagAvailable(tag, itemEl.item && itemEl.item.productData);
  }

  /* The wishlisted size is sold out, but the size panel can still reach the
     ones that aren't - so the button needs to stay clickable. */
  function enableAddToCartForOtherSizes(itemEl) {
    if (isSaveForLaterItem(itemEl)) return;

    var button = itemEl.querySelector('.swym-storefront-layout-grid-item-add-to-cart-button[data-action="add-to-cart"]');
    if (!button || !button.disabled) return;
    if (itemEl.selectedVariant && itemEl.selectedVariant.available) return; // disabled for another reason
    if (isAddToCartDisabledByTag(itemEl)) return; // merchant disabled it deliberately
    if (!hasAvailableSizeSibling(itemEl)) return; // every size sold out

    button.removeAttribute('disabled');
  }

  /* The card always represents the first size, so showing a size label there is
     misleading. renderVariants() emits one .swym-storefront-layout-variant per
     option in option order, with dividers between, so drop the size one. */
  function removeSizeVariantLabel(itemEl) {
    var productData = itemEl.item && itemEl.item.productData;
    var options = productData && productData.options;
    if (!options || !options.length) return;

    var sizeIndex = getSizeOptionIndex(options);
    if (sizeIndex === -1) return;

    var container = itemEl.querySelector('.swym-storefront-layout-grid-item-variants-container');
    if (!container) return;

    var labels = container.querySelectorAll('.swym-storefront-layout-variant');
    var dividers = container.querySelectorAll('.swym-storefront-layout-variant-devider');
    if (!labels[sizeIndex]) return;

    labels[sizeIndex].remove();

    // The divider before it, or the one after when size is the first option.
    var divider = sizeIndex > 0 ? dividers[sizeIndex - 1] : dividers[0];
    if (divider) divider.remove();

    // Nothing left to show: drop the container and the price separator too.
    if (!container.querySelector('.swym-storefront-layout-variant')) {
      var priceDivider = itemEl.querySelector('.swym-storefront-layout-price-devider');
      if (priceDivider) priceDivider.remove();
      container.remove();
    }
  }

  var ItemElement = window.customElements && customElements.get('swym-storefront-layout-item');

  if (ItemElement && typeof ItemElement.prototype.getButtonState === 'function') {
    var originalGetButtonState = ItemElement.prototype.getButtonState;
    ItemElement.prototype.getButtonState = function () {
      if (!isSaveForLaterItem(this)) {
        // Any size of this product in the cart counts as added to cart.
        if (anySizeSiblingInCart(this)) {
          return getStrings().addedToCart || 'Added To Cart';
        }
        // Sold out in the wishlisted size only - other sizes are still buyable.
        if (this.selectedVariant && !this.selectedVariant.available && hasAvailableSizeSibling(this)) {
          return getStrings().addToCart || 'Add To Cart';
        }
      }
      return originalGetButtonState.apply(this, arguments);
    };
  }

  /* renderItem() is always followed by initItemElements(), so wrapping it
     re-applies the enabled state on every render without touching vendor code. */
  if (ItemElement && typeof ItemElement.prototype.initItemElements === 'function') {
    var originalInitItemElements = ItemElement.prototype.initItemElements;
    ItemElement.prototype.initItemElements = function () {
      var result = originalInitItemElements.apply(this, arguments);
      enableAddToCartForOtherSizes(this);
      removeSizeVariantLabel(this);
      return result;
    };
  }

  /* --------------------------------------------------------------------
     5. Move to Wishlist on the cart page
     Saves the line's first-size variant, then removes the line from the cart
     by triggering the theme's own remove control so the cart re-renders as
     normal. The cart is only touched once the save succeeds.
     -------------------------------------------------------------------- */
  function resolveWishlistId(swat, callback) {
    var defaultList = window.SwymStorefrontLayoutContext &&
      window.SwymStorefrontLayoutContext.DefaultList;
    if (defaultList && defaultList.lid) return callback(defaultList.lid);

    swat.fetchLists({
      lty: 'wl',
      callbackFn: function (lists) {
        callback(lists && lists.length ? lists[0].lid : null);
      },
      errorFn: function () { callback(null); }
    });
  }

  /* Clicking the hidden trigger next to the button lets the theme's own
     delegated remove-item handler do the AJAX update and cart re-render. */
  function removeCartLine(button) {
    var line = button.dataset.swymcsLine;
    var lineItem = button.closest('.CartItem');
    var removeLink = lineItem &&
      lineItem.querySelector('.swymcs-remove-line[data-line="' + line + '"]');

    if (removeLink) {
      removeLink.click();
    } else {
      window.location.href = window.Shopify.routes.root + 'cart/change?quantity=0&line=' + line;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.swymcs-move-to-wishlist');
    if (!button || button.disabled) return;

    event.preventDefault();

    var product = {
      epi: parseInt(button.dataset.swymcsEpi, 10),
      empi: parseInt(button.dataset.swymcsEmpi, 10),
      du: button.dataset.swymcsDu
    };

    button.disabled = true;

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      resolveWishlistId(swat, function (lid) {
        if (!lid) {
          button.disabled = false;
          window._swat && window._swat.utils.error('Move to Wishlist: no wishlist found');
          return;
        }
        swat.addToList(lid, product, function () {
          removeCartLine(button);
        }, function (error) {
          button.disabled = false;
          window._swat && window._swat.utils.error('Move to Wishlist failed:', error);
        });
      });
    });
  });

  /* --------------------------------------------------------------------
     6. Mobile "added to cart" backdrop doesn't clear on outside click
     Tapping the .PageOverlay only removes #mobile-sidebar-cart's active
     class (see custom.js), leaving the overlay itself visible and the page
     scroll-locked. Restore the two cleanup steps the explicit close button
     does, scoped to this drawer only so other .PageOverlay usages (modals,
     desktop cart) are untouched.
     -------------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.PageOverlay')) return;

    var mobileCart = document.getElementById('mobile-sidebar-cart');
    if (!mobileCart || !mobileCart.classList.contains('active')) return;

    document.documentElement.classList.remove('no-scroll');
    event.target.closest('.PageOverlay').classList.remove('is-visible');
  }, true);

  /* --------------------------------------------------------------------
     4. Copy for the empty wishlist, guest and logged in
     These strings come from the Swym app settings rather than the theme
     locale file, so set them just before the empty state is rendered.
     -------------------------------------------------------------------- */
  var ListElement = window.customElements && customElements.get('swym-storefront-layout-default-wishlist');
  if (ListElement && typeof ListElement.prototype.setData === 'function') {
    var originalListSetData = ListElement.prototype.setData;
    ListElement.prototype.setData = function () {
      var strings = window.SwymStorefrontLayoutContext && window.SwymStorefrontLayoutContext.Strings;
      if (strings) {
        strings.emptyGuestTitle = EMPTY_WISHLIST_TITLE;
        strings.emptySingleLoggedInTitle = EMPTY_WISHLIST_TITLE;
        strings.emptyGuestLoginCTA = GUEST_EMPTY_LOGIN_CTA;
      }
      return originalListSetData.apply(this, arguments);
    };
  }
})();
